import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import DeliveryOrder from "../../../containers/modules/sales/delivery-order";

export default function DeliveryOrderRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="delivery-order"
      index
        element={
        <AccessControl
            name={"Delivery Order List"}
            auth={authUser}
            component={() => <DeliveryOrder />}
        />
        }
    />
  );
}
